import Factory from "@/schemas/factory";

const schema = new Factory()
    .hasId()
    .translatable()
    .hasTitle()
    .hasTimestamps()
	.hasSection()
    .make();

export default schema;
